import { render, staticRenderFns } from "./ActionStudy.vue?vue&type=template&id=35337028&"
import script from "./ActionStudy.vue?vue&type=script&lang=js&"
export * from "./ActionStudy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports